import React, {useEffect, useState} from "react";
import "./Basket.scss";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket, useResp} from "../../hooks";
import {OnlineSearch} from "../../Components";
import {AddBasket, GetBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import Rodal from "rodal";
import {DeleteBasket} from "../OnlineStore/OnlineStoreService";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import BasketResponsive from "../BasketResponsive/BasketResponsive";
import ProductResponsive from "../ProductResponsive/ProductResponsive";
import {notification} from "antd";

let basketErrors = [];




function checkStock(cat,count){
    if(cat.stock-count>0){
        return "online-sub-categories-item online-sub-categories-item-exist"
    }
    else if(cat.stock===0){
        return "online-sub-categories-item online-sub-categories-item-notExist"
    }
    else if(cat.stock-count<0){
        return "online-sub-categories-item online-sub-categories-item-lowExist"
    }else {
        return "online-sub-categories-item online-sub-categories-item-exist"
    }

}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function BasketAddRemoveSub({item,reSort,setCount}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();

    //states
    const [loading,set_loading] = useState(false)


    useEffect(()=>{

    },[])


    const addToBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId,pId,item)
        console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId,pId)
        console.log("Remove : ",response)
    }

    //functions
    const inc = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if(basket.find(product=>product.product.uid===item.uid)){
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count+1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket",JSON.stringify(filter));
            //local basket
            reSort(filter)
        }else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product:item,count:1}]);
            //storage change
            localStorage.setItem("basket",JSON.stringify([...basket, {product:item,count:1}]));
            reSort([...basket, {product:item,count:1}])
        }
    }

    const dec = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product=>product.product.uid===item.uid);
        if(find){
            //exist
            if(find.count>0){
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count-1} : pro)

                if(find.count===1){
                    //context change
                    setBasket(basket.filter(product=>product.product.uid!==item.uid))
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                    //local basket
                    reSort(basket.filter(product=>product.product.uid!==item.uid))
                }else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(filter));
                    //local basket
                    reSort(filter)
                }
            }else {
                //context change
                setBasket(basket.filter(product=>product.product.uid!==item.uid))
                //storage change
                localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                //local basket
                reSort(basket.filter(product=>product.product.uid!==item.uid))
            }
        }
    }

    const remove = () =>{
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product=>product.product.uid!==item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(()=>{
            localStorage.setItem("basket",JSON.stringify(basket));
        },500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product=>product.product.uid===item.uid);
        if(basket_count){
            setCount(basket_count.count)
            return basket_count.count;
        }

        setCount(0)
        return 0;
    }

    return(
        <div className="add-remove-section-sub">
            {checkCount()>0?<>
                <i className="fa fa-minus" onClick={dec}></i>
                <span className="product-count-number">
                    {!loading?checkCount():<i className="fa fa-spinner fa-spin"></i>}
                </span>
            </>:null}
            {/*{item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:<span className="stock-over">ناموجود</span>}*/}
            <i className="fa fa-plus" onClick={inc}></i>
        </div>
    )
}



function OnlineSubCatCard({cat,merchantId,reSort,errors,set_errors}) {
    //hooks
    const history = useHistory();

    const  [count,set_count] = useState(0)
    const  [status,set_status] = useState("exist")

    function reCheckBasketError(id) {
        let find = errors.find(b=> b===id)
        if(find)
            set_errors(errors.filter(b=> b!==id))
    }

    function addBasketError(id) {
        let find = errors.find(b=> b===id)
        if(!find)
            set_errors([...errors,id])
    }

    useEffect(()=>{
        console.log("RRRRRRRRRRRRRRRRRRRRRRRR : ",cat.stock,count)
            if(cat.stock-count>0){
                reCheckBasketError(cat.uid)
            }
            else if(cat.stock===0){
                addBasketError(cat.uid)
            }
            else if(cat.stock-count<0){
                addBasketError(cat.uid)
            }else {
                reCheckBasketError(cat.uid)
            }
    },[count])

    useEffect(()=>{

    },[])


    return(
        <div className={checkStock(cat,count)}  >
            <div className="online-sub-categories-count">
                <BasketAddRemoveSub item={cat} reSort={reSort} setCount={set_count}/>
                <span className="online-sub-categories-stock">{cat.stock} موجودی </span>
                {/*<span className="online-sub-categories-stock">{status}</span>*/}
            </div>

            {/*<div className="add-re-section">*/}
            {/*    /!*<i className="fa fa-plus"></i>*!/*/}
            {/*    <div className="count">1</div>*/}
            {/*    <i className="fa fa-trash"></i>*/}
            {/*</div>*/}

            <div className="info-section" onClick={()=>{
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <span>{cat.name}</span>
                <div className="price-section">
                    {cat.price!==cat.price_original?<span  className="original-price">{numberWithCommas(cat.price_original)} </span>:null}
                    <span style={{direction:"rtl"}} className="price">{numberWithCommas(cat.price)}  ریال </span>
                </div>
            </div>
            <div className="img-section" onClick={()=>{
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <img src={cat.image} alt=""/>
                {cat && cat.discount_percentage!==0?
                    <div className="off">
                        {cat.discount_percentage+" % "}
                    </div>:
                    null
                }

            </div>
        </div>
    )
}



function Basket() {

    const history = useHistory();
    const [total , set_total] = useState(0);
    const [off , set_off] = useState(0);
    const [price , set_price] = useState(0);
    const [basket , set_basket] = useState(0);
    const [merchantId , set_merchantId] = useState("merchantId");
    const basketDispatch = useDispatchBasket();
    const myBasket = useBasket();
    const [showModal,set_showModal] = useState(false);
    const [merchant,set_merchant] = useState({});


    const showMess = (productsList) => {
        const key = `open${Date.now()}`;
        let genList = ``;

        productsList.forEach(p =>{
            genList += `\n ${p} \n`
        })


        notification.config({
            duration: 7,
        });

        notification['warning']({
            message:"این موارد به علت ناموجود بودن از سبد شما حذف شد",
            description: (
                <ul>
                    {productsList.map((p) =>{
                        return(
                            <li className="guest-message-item">
                                {p}<br />
                            </li>
                        )
                    })}
                </ul>
            ),
            key,
            style: {
                zIndex:2003
            },
        });
    }


    const checkGuestBasketMessages = ()=>{
        let guestMessageLocal = localStorage.getItem('guestBasketResponse')
        if(guestMessageLocal){
            let guestMessages =  JSON.parse(guestMessageLocal)
            console.log("show Guest Messages : ",guestMessages)
            localStorage.removeItem('guestBasketResponse');
            if(guestMessages?.not_available?.length > 0){
                showMess(guestMessages.not_available)
            }
        }
    }

    useEffect(()=>{
        console.log("HHHHHHHHHHHHHHHHHHHH h")
        let mId = window.location.pathname.split("/")[2]
        set_merchantId(mId)
        basketApi();
        checkGuestBasketMessages()
    },[])

    useEffect(()=>{
        //get storage count
        let local_basket = localStorage.getItem('basket');
        if(local_basket){
            basketDispatch(JSON.parse(local_basket))
        }else {
            basketDispatch([])
        }
    },[])

    useEffect(()=>{
        let local_basket = localStorage.getItem("basket");
        if(local_basket){
            let basket = JSON.parse(local_basket)
            console.log("Basket : ",basket)
            set_basket(basket);
            let {total,off,price} =  calc_info(basket);
            set_off(off);
            set_total(total);
            set_price(price);
        }
    },[])

    const checkBasketErrors = (data)=>{
        data.items.forEach(d=>{
            if(d.quantity>d.product.stock){
                set_errors([...errors,d.product.uid])
            }
        })
    }


    const basketApi = async () =>{
        const response = await GetBasket();
        checkBasketErrors(response.data)
        if(response.data.merchant){
            set_merchant(response.data.merchant)
        }
        //sync local basket with api basket
        if(response.data.items &&  response.data.items.length>0){
            let maped = response.data.items.map(item=>{
                return {count:item.quantity,product:item.product}
            })
            basketDispatch(maped)
            localStorage.setItem("basket",JSON.stringify(maped))
            reSort(maped)
        }else {
            //empty
            basketDispatch([])
            localStorage.setItem("basket",JSON.stringify([]))
            reSort([])
        }
    }

    const calc_info = (basket) =>{
        let total = 0
        let off = 0
        let price = 0;
        basket.forEach(item=>{
            let count = item.count;
            let orig = item.product.price_original;
            let dis = item.product.discount;
            total += count*orig;
            off += count*dis;
        })

        console.log("res : ",total,off);

        price = total - off ;
        return {total,off,price};
    }

    const reSort = (basket) =>{
        set_basket(basket);
        let {total,off,price} =  calc_info(basket);
        set_off(off);
        set_total(total);
        set_price(price);
    }

    const removeBasket = () =>{
        localStorage.removeItem("basket");
        DeleteBasket()
        basketDispatch([])
        reSort([])
        set_showModal(false)
    }

    const { height, width,mobileWidth } = useWindowDimensions();
    const resp = useResp()

    const [errors,set_errors] = useState([])

    return(
        <>
            {resp?<BasketResponsive price={price} off={off} total={total} reSort={reSort} merchant={merchantId} basket={basket}/>:null}
            {!resp?        <>
                    <div className="basket-brand" onClick={()=>{history.push(`/online-style-shop/${merchantId}`)}}>
                        <img src={merchant.thumbnail} alt=""/>
                    </div>
                    <div className="online-basket-container">
                        <Rodal
                            customStyles={{ height: 'auto', bottom: 'auto', top: '40%', transform: 'translateY(-40%)',width:'300px'}}
                            animation={"zoom"} visible={showModal} onClose={()=>set_showModal(false)}>
                            <div className="remove-basket-confirm">
                                <br/>
                                <span className="confirm-title">آیا مایل به حذف کل سبد خرید می باشید ؟</span>
                                <div className="confirm-btns-row">
                                    <span className="remove-basket" onClick={removeBasket}>بله</span>
                                    <span className="redirect-basket" onClick={()=>{
                                        set_showModal(false)
                                    }}>خیر</span>
                                </div>
                            </div>
                        </Rodal>
                        <div className="online-header-section" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                            <i className="fa fa-arrow-left"
                               onClick={()=>{
                                   history.goBack()
                               }}
                            ></i>
                            <span>سبد خرید</span>
                            {price>0?<i className="fa fa-trash"
                                        onClick={()=>{
                                            set_showModal(true)
                                        }}
                            ></i>:null}
                        </div>
                        {price>0? <div className="basket-info-section">
                            <div className="total-section">
                                <span> {numberWithCommas(total)} ریال </span>
                                <span>مجموع</span>
                            </div>
                            <div className="off-section">
                                <span> {numberWithCommas(off)} ریال </span>
                                <span>مجموع تخفیف اقلام</span>
                            </div>
                            <div className="price-section">
                                <span> {numberWithCommas(price)} ریال </span>
                                <span>مبلغ قابل پرداخت</span>
                            </div>
                        </div>:null}

                        <div className="online-sub-categories-container" style={{paddingBottom:100,margin:"0 16px"}}>
                            {price<1?
                                <div className="cartEmpty">
                                    <span>محصولی در سبد موجود نمی باشد</span>
                                </div>
                                :null}
                            {basket && basket.map(item=>{
                                return(
                                    <OnlineSubCatCard cat={item.product} reSort={reSort} merchantId={merchantId} errors={errors} set_errors={set_errors}/>
                                )
                            })}
                        </div>
                        <div className="online-product-footer" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                            {price>0?<div className="notAdded-mode">
                                <div className="add-to-basket-btn" onClick={()=>{
                                    console.log(errors)
                                    if(errors.length<1){
                                        history.push(`/online-store-sendinfo/${merchantId}`)
                                    }
                                }}>
                                    {errors.length>0?<span>لطفا سبد خرید خود را اصلاح نمایید</span>:<span>ادامه فرایند خرید</span>}
                                </div>
                            </div>:null}
                        </div>
                    </div>

                    <div className="online-product-footer-md">
                        {price>0?<div className="notAdded-mode-md">
                            <div className="add-to-basket-btn" onClick={()=>{
                                if(localStorage.getItem('shop_token')){
                                    history.push("/online-store-sendinfo")
                                }else {
                                    console.log("---")
                                }
                            }}>
                                <span>ادامه فرایند خرید</span>
                            </div>
                            <div className="add-to-basket-btn" onClick={()=>{
                                history.goBack()
                            }}>
                                <span>برگشت</span>
                            </div>
                        </div>:null}
                    </div>
                </>
                :null}
            </>
    )
}

export {Basket};
